/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import {
  OG_IMG,
  OG_SITE_NAME,
} from "../constants/fallback";

const Seo = ({
  description,
  lang,
  meta,
  title,
  pageURI,
  image,
}) => {
  const { wp, wpUser } = useStaticQuery(
    graphql`
      query {
        wp {
          generalSettings {
            title
            description
          }
        }

        # if there's more than one user this would need to be filtered to the main user
        wpUser {
          twitter: name
        }
      }
    `
  );

  const metaDescription =
    description || wp.generalSettings?.description;
  const defaultTitle = wp.generalSettings?.title;
  const siteUrl = process.env.GATSBY_SITE_URL;
  const host = process.env.GATSBY_SITE_HOST;

  const uri = !pageURI ? "/" : pageURI;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      link={[
        { rel: "canonical", href: `${siteUrl}${uri}` },
      ]}
      titleTemplate={
        defaultTitle ? `%s | ${defaultTitle}` : null
      }
      meta={[
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "og:site_name",
          content: OG_SITE_NAME,
        },
        {
          property: "og:description",
          content: metaDescription,
        },
        {
          property: "og:url",
          content: `${siteUrl}${pageURI}`,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:image",
          content: image ? `${host}${image}` : OG_IMG,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:domain",
          content: "https://share.market",
        },
        {
          name: "twitter:url",
          content: `${siteUrl}${pageURI}`,
        },
        {
          name: "twitter:creator",
          content: wpUser?.twitter || "",
        },
        {
          name: "twitter:title",
          content: title,
        },
        {
          name: "twitter:description",
          content: metaDescription,
        },
        {
          name: "twitter:image",
          content: image ? `${host}${image}` : OG_IMG,
        },
        {
          name: "viewport",
          content:
            "width=device-width, minimum-scale=1.0 initial-scale=1",
        },
      ].concat(meta)}
    />
  );
};

Seo.defaultProps = {
  lang: "en",
  meta: [],
  description: "",
  pageURI: "",
  image: "",
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  pageURI: PropTypes.string,
  image: PropTypes.string,
};

export default Seo;
